import { Intent, Label } from "@blueprintjs/core";
import { observer } from "mobx-react";
import { Icon } from "@blueprintjs/core";
import { IconName } from "@blueprintjs/icons";
import { BaseFieldProps, CoreFieldValue } from "../../types/fieldTypes";
import classNames from "classnames";
import {
  RelativityTooltipV2,
  TooltipV2Props,
} from "../../../Tooltip/RelativityTooltipV2";
import { useContext } from "react";
import { FormFieldConfigContext } from "../../../FieldSchema/FormFieldConfigContext";

export interface FieldLabelProps {
  labelName: string | React.ReactNode;
  labelOnTop?: boolean;
  tooltipDescription?: string;
  intent?: Intent;
  icon?: IconName;
  disabled?: boolean;
  classNames?: classNames.ArgumentArray;
  fieldProps?: BaseFieldProps<CoreFieldValue>;
  tooltipProps?: Omit<TooltipV2Props, "shouldShowTooltip" | "content">;
  onClick?: (fieldProps?: Partial<BaseFieldProps<CoreFieldValue>>) => void;
  isRequired?: boolean;
}

export const FieldLabel: React.FC<FieldLabelProps> = observer((props) => {
  const formFieldConfigContextValue = useContext(FormFieldConfigContext);
  const showRequiredFieldAsteriskIsConfigured =
    !!formFieldConfigContextValue?.showRequiredFieldAsterisk;
  const showRequiredFieldAsterisk =
    showRequiredFieldAsteriskIsConfigured && !!props.isRequired;

  return (
    <Label
      className={classNames(
        "ucl-field-label",
        {
          "ucl-field-label-clickable": props.onClick,
          "bp5-disabled": props.disabled,
          "require-asterisk": showRequiredFieldAsterisk,
        },
        props.classNames
      )}
      disabled={props.disabled}
      onClick={() => {
        props.onClick && props.onClick(props.fieldProps);
      }}
    >
      <span className="ucl-label-title">
        {props.labelName}
        {showRequiredFieldAsterisk && (
          <span className="ucl-label-asterisk">*</span>
        )}
      </span>

      <RelativityTooltipV2
        shouldShowTooltip={true}
        {...props.tooltipProps}
        content={props.tooltipDescription || ""}
        disabled={props.disabled}
      >
        {!!props.tooltipDescription && (
          <Icon
            size={15}
            icon={!!props.icon ? props.icon : "info-sign"}
            intent={!!props.intent ? props.intent : Intent.NONE}
          />
        )}
      </RelativityTooltipV2>
    </Label>
  );
});
